import autosize from 'autosize/dist/autosize.min';

export default {
  init() {
    // JavaScript to be fired on the home page
    autosize($('textarea'));

    const focusInquiryName = ({ scrollToForm = false } = {}) => {
      const formSection = document.getElementById('contact-form');
      const nameField = document.getElementById('input_1_1');

      if (nameField) {
        window.setTimeout(() => {
          if (scrollToForm && formSection) {
            formSection.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }

          nameField.focus({
            preventScroll: true,
          });
        }, 350);
      }
    };

    $('.gbr-home a[href="#contact-form"], .gbr-home a[href="/#contact-form"]').on('click', () => {
      focusInquiryName();
    });

    if (window.location.hash === '#contact-form') {
      focusInquiryName();
    } else if (window.location.hash === '#contact2') {
      focusInquiryName({
        scrollToForm: true,
      });
    }

    const galleryGrid = document.querySelector('.gbr-gallery-grid');

    if (galleryGrid) {
      const galleryItems = galleryGrid.querySelectorAll('figure');

      galleryGrid.classList.add('gbr-gallery-grid-animated');

      if ('IntersectionObserver' in window) {
        const galleryObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, {
          rootMargin: '0px 0px -8%',
          threshold: 0.12,
        });

        galleryItems.forEach((item) => galleryObserver.observe(item));
      } else {
        galleryItems.forEach((item) => item.classList.add('is-visible'));
      }
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
